import axios from 'axios'
export default {
  data () {
    return {
      error: null,
      loading: true,
      loadedData: {},
      progress: 0
    }
  },

  methods: {
    setLoading (loading) {
      this.loading = loading
    },

    // TODO: re-investigate internal component Data handling
    // in regards to path index.
    setData (path, data) {
      this.loadedData = {}
      this.loadedData[path] = data
    },

    cashData (path, data, key = false) {
      // key = !key ? path.replace('/', '-') : key
      // this.cashChildren(data)
      // this.$ls.set(key, data)
    },

    setError (error) {
      this.error = error
    },

    getUrl (path) {
      // const baseUrl = 'http://localhost:8888/caam/caam_live/sirvy/'
      // const baseUrl = 'https://caamuseum.org/sirvy/'
      const baseUrl = 'https://staging.caamuseum.org/sirvy/'
      return baseUrl + path
    },

    cashChildren (data) {
      // if (data.children) {
      //   const c = data.children
      //   for (let i in c) {
      //     // const path = c[i].id.replace('/', '-')
      //     // this.$ls.set(path, c[i])
      //   }
      // }
    },

    requestData (path, service = 'tree', params = {}) {
      const lsPath = path.replace('/', '-')
      let data = this.$ls.get(lsPath)
      params['service'] = service
      if (!data) {
        this.request('get', path, params)
      } else {
        this.setData(path, data)
        this.setLoading(false)
      }
    },

    request (method, path, params = {}) {
      const url = this.getUrl(path)
      this.error = null
      this.setLoading(true)
      // this.$Progress.start()
      axios[method](url, { params })
      .then(response => {
        this.cashData(path, response.data)
        this.setData(path, response.data)
        this.setLoading(false)
        // this.$Progress.finish()
      })
      .catch(error => {
        this.setError(error)
        // this.$Progress.fail()
      })
    },

    post (url, data, callback) {
      axios.post(url, JSON.stringify(data))
      .then(response => {
        callback(response)
      })
      .catch(error => {
        console.log(error)
      })
    },

    get (url, callback) {
      axios.get(url)
      .then(response => {
        callback(response)
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DataMixin.js